export default __webpack_public_path__ + "static/media/black-searcch-m.49a20e13.svg";